import { Box, Typography } from '@mui/material';
import { ChatBubbleOutlineOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useUnreadCount } from '@/features/messages/hooks/useUnreadCount';

export function HomeMessagesSummary() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { count } = useUnreadCount();

  const handleClick = () => {
    navigate('/messages');
  };

  return (
    <Box
      data-testid="home-messages-summary"
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') handleClick();
      }}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        px: 2,
        py: 1.2,
        borderRadius: 1,
        bgcolor: 'background.paper',
        boxShadow: 1,
        cursor: 'pointer',
        '&:hover': { boxShadow: 3 },
        '&:active': { opacity: 0.85 },
      }}
    >
      {/* Dark chat icon */}
      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: 1,
          bgcolor: 'primary.main',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <ChatBubbleOutlineOutlined sx={{ color: 'white', fontSize: 24 }} />
      </Box>

      {/* Label */}
      <Typography variant="body1" sx={{ flex: 1, fontWeight: 500, color: 'text.primary' }}>
        {t('home.messages.summary', { count })}
      </Typography>

      {/* Count badge */}
      <Box
        data-testid="home-messages-summary-count"
        sx={{
          minWidth: 28,
          height: 28,
          borderRadius: '50%',
          bgcolor: 'primary.main',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 0.5,
        }}
      >
        <Typography variant="caption" sx={{ fontWeight: 700, color: 'white', lineHeight: 1 }}>
          {count > 99 ? '99+' : count}
        </Typography>
      </Box>
    </Box>
  );
}
